import Loading from '@/components/Loading/Loading';
import { useRegister } from '@/hooks/card/useRegister';
import { failedPaymentStatuses, successfulPaymentStatuses } from '@/utils/constants';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CardCallback = () => {
  const navigate = useNavigate();
  const { paymentSession, setPaymentSessionId, queryErrorPaymentSession } = useRegister();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paymentSessionId = searchParams.get('PaymentSessionId');
    if (paymentSessionId) {
      setPaymentSessionId(paymentSessionId);
    }
  }, [setPaymentSessionId, searchParams]);

  useEffect(() => {
    if (paymentSession) {
      if (successfulPaymentStatuses.includes(paymentSession.payment.status?.toLowerCase())) {
        navigate(`/card/confirmation/${paymentSession.paymentSessionId}`, { replace: true });
      } else if (failedPaymentStatuses.includes(paymentSession.payment.status?.toLowerCase())) {
        navigate(`/card/error`, { replace: true });
      }
    }
  }, [paymentSession]);

  useEffect(() => {
    if (queryErrorPaymentSession) {
      navigate('/card/error', { replace: true });
    }
  }, [queryErrorPaymentSession]);

  return <Loading height='50vh' />;
};

export default CardCallback;
